import Browser from '../core/browser'
// import { EventBus } from '../core/smpl-components'

// ...existing code...
const BREAKPOINTS = {
	XSMALL: 0,
	SMALL: 576,
	MEDIUM: 768,
	LARGE: 992,
	XLARGE: 1280,
	XXLARGE: 1536,
	XXCLARGE: 1920,
}

export const initGlobals = () => {
	const context = {
		breakpoints: BREAKPOINTS,
		browser: new Browser(),
		// eventBus: new EventBus(),
	}

	window.THEME_BREAKPOINTS = BREAKPOINTS
	window.app = context

	return context
}
